<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'labElement', params: {} }">
            Lab Element
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'labElementView', params: {} }">
              View Lab Element
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Lab Element
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="labElement.symbol">
            <td max-width="35%" class="text-subtitle-1">Symbol:</td>
            <td>{{ labElement.symbol }}</td>
          </tr>
          
          <tr v-if="labElement.element_name">
            <td max-width="35%" class="text-subtitle-1">Name:</td>
            <td>{{ labElement.element_name }}</td>
          </tr>
          
          <tr v-if="labElement.chinese_name">
            <td max-width="35%" class="text-subtitle-1">Chinese Name:</td>
            <td>{{ labElement.chinese_name }}</td>
          </tr>
          
          <tr v-if="labElement.thai_name">
            <td max-width="35%" class="text-subtitle-1">Thai Name:</td>
            <td>{{ labElement.thai_name }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getLabElement } from "@/services/labElement";
    

    export default {
      data() {
        return {
            id: '',
            labElement: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "labElementEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getLabElement(this.id)
            .then((response) => {
              this.labElement = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading labElement");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    